import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route} from 'react-router';

import Home from './home';

import SignOut from './auth/Signout';

import Playbooks from './playbooks/Playbooks';
import Skills from './skills/Skills';
import Automations from './automations/Automations';
import CasePage from './case/CasePage';
import DomainGuideList from './domain_guide/DomainGuideList';
import DomainGuideView from './domain_guide/DomainGuideView';

import MyDay from './tasks/MyDay';
import AllTasks from './tasks/AllTasks';

import CaregiverList from './caregiver/CaregiverList';
import CaregiverNew from './caregiver/CaregiverNew';
import CaregiverView from './caregiver/CaregiverView';

import ClientList from './client/ClientList';
import ClientNew from './client/ClientNew';
import ClientView from './client/ClientView';

import ClientLeadList from './client_lead/ClientLeadList';

import ManageUser from './admin/user/ManageUser';

import CaregiverScheduleDashboardPage from './schedule/CaregiverScheduleDashboardPage';
import ClientScheduleDashboardPage from './schedule/ClientScheduleDashboardPage';

import EventDetailPage from './schedule/EventDetailPage';

import CareerDashboard from './career/CareerDashboard';
import CreateJob from './career/JobCreation';
import EditJob from './career/JobEdit';
import JobView from './career/JobView';
import LeadFunnelPage from './metrics/LeadFunnel';
import AgentReportCardPage from './metrics/AgentReportCard';
import AgentChat from './agent/AgentChat';
import Routines from './routines/Routines';

import featureFlags from 'utils/feature_flags/feature_flags';

const Router = () => {
  return (
    <Routes>
      <Route path="/" Component={Home} />

      <Route path="/signout" Component={SignOut} />

      <Route path="/admin/user" Component={ManageUser} />
      <Route path="/admin/user/new" Component={ManageUser} />
      <Route path="/admin/user/:userRn/deactivate" Component={ManageUser} />

      <Route path="/playbooks" Component={Playbooks} />
      <Route path="/skills" Component={Skills} />
      <Route path="/cases" Component={CasePage} />
      <Route path="/case/:caseRn" Component={CasePage} />
      <Route path="/domain-guides" Component={DomainGuideList} />
      <Route path="/domain-guide/:domainGuideRn" Component={DomainGuideView} />

      <Route path="/tasks/my-day" Component={MyDay}/>
      <Route path="/tasks/all-tasks" Component={AllTasks}/>

      <Route path="/caregiver" Component={CaregiverList} />
      <Route path="/caregiver/new" Component={CaregiverNew} />
      <Route path="/caregiver/:caregiverRn" Component={CaregiverView} />

      <Route path="/client" Component={ClientList} />
      <Route path="/client/new" Component={ClientNew} />
      <Route path="/client/:clientRn" Component={ClientView} />

      <Route path="/client_lead" Component={ClientLeadList} />

      <Route path="/automations" Component={Automations} />
      <Route path="/metrics/lead-funnel" Component={LeadFunnelPage} />
      {
        featureFlags.oversightMarkingReadsEnabled &&
        <Route path="/metrics/agent-report-card" Component={AgentReportCardPage} />
      }

      <Route path="/agent/chat" Component={AgentChat} />
      <Route path="/agent/routines" Component={Routines} />

      <Route path="/schedule/client" Component={ClientScheduleDashboardPage} />
      <Route path="/schedule/caregiver" Component={CaregiverScheduleDashboardPage} />
      <Route path="/schedule/event/:eventRn" Component={EventDetailPage} />

      <Route path="/career" Component={CareerDashboard} />
      <Route path="/career/create" Component={CreateJob} />
      <Route path="/career/:jobRn" Component={JobView} />
      <Route path ="/career/:jobRn/edit" Component={EditJob} />

    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

